import {
  createTolgeeBrowserInstance,
  getLanguageOnlyFromLocale,
} from "@msys/tolgee";
import * as Sentry from "@sentry/react";
import moment from "moment";
import * as Yup from "yup";
import { loadCalendarTranslation } from "./syncfusion.js";
import { yupTranslations } from "./yupTranslations.js";

export const tolgee = createTolgeeBrowserInstance(
  import.meta.env.VITE_TOLGEE_CDN_URL,
  {
    onFetchFailed: ({ language, namespace, url, error, phase }) => {
      Sentry.captureMessage(
        `Tolgee: failed to fetch translations ${namespace ?? ""}/${language}`,
        {
          level: "warning",
          tags: {
            tolgee_language: language,
            tolgee_namespace: namespace ?? "",
            tolgee_phase: phase,
          },
          // Group all occurrences of the same missing record; the default
          // message grouping would split by URL (CDN hash differs per env).
          fingerprint: ["tolgee-fetch-failed", language, namespace ?? ""],
          extra: { url, error: String(error) },
        }
      );
    },
  }
);

// `newLocale` here has only supported languages, but can also have sub-locales, like: en-GB, en-US, de-CH, fr-BE and so on
tolgee.on("language", ({ value: tolgeeLanguage }) => {
  moment.locale(tolgeeLanguageToMomentLocale(tolgeeLanguage));
  Yup.setLocale(yupTranslations[getLanguageOnlyFromLocale(tolgeeLanguage)]);
  loadCalendarTranslation(toleeLanguageToEj2Locale(tolgeeLanguage));
});

function tolgeeLanguageToMomentLocale(tolgeeLanguage: string) {
  switch (tolgeeLanguage) {
    case "en":
      return "en-GB";
    default:
      return getLanguageOnlyFromLocale(tolgeeLanguage);
  }
}

function toleeLanguageToEj2Locale(tolgeeLanguage: string) {
  switch (tolgeeLanguage) {
    case "en":
      return "en-GB";
    default:
      return getLanguageOnlyFromLocale(tolgeeLanguage);
  }
}
